$(function () {

    /**
     * REGIONS MAP SVG
     */

    $('#regions-map-svg path[id]').on('click', function(e) {
        selectRegion(e.currentTarget.id);
    });

    $('select[name="attr_state[]"]').on('change', function() {
        selectRegion(this.value);
    });

    function selectRegion(id) {
        $('#regions-map-svg path[id]').removeClass('selected');
        $('#regions-map-svg path[id="' + id + '"]').addClass('selected');
        $('select[name="attr_state[]"]').val(id);
    }

    /**
     * FIN - REGIONS MAP SVG
     */

});

